"use client";

import { FC, useMemo } from "react";
import { IBannerResponse } from "@finbackoffice/clientbff-client";
import { TranslationScopes } from "@finbackoffice/enums";
import { BonusPagesEnum } from "@finbackoffice/fe-core";
import ErrorBoundary from "components/base/error-boundary/ErrorBoundary";
import PromoContent from "components/bonuses/promotions/PromoContent";
import { useCasinoGames } from "hooks";

type IProps = {
    banners: IBannerResponse[];
    gameId: string;
    translationScope: TranslationScopes;
    promoPageName: BonusPagesEnum;
};

export const BonusesPromotionsCasinoGameScreen: FC<IProps> = ({
    banners,
    gameId,
    translationScope,
    promoPageName,
}) => {
    const gameTypesMemo = useMemo(() => [], []);
    const { casinoGamesState } = useCasinoGames(gameTypesMemo, "", "All", {
        gameId,
    });
    const casinoGame = casinoGamesState.games.length ? casinoGamesState.games[0] : null;

    return (
        <ErrorBoundary name={PromoContent.name}>
            <PromoContent
                casinoGame={casinoGame}
                banners={banners}
                translationScope={translationScope}
                promoPageName={promoPageName}
            />
        </ErrorBoundary>
    );
};
